// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as CommonErrorContentCmp from "./CommonErrorContentCmp.bs.js";
import * as CommonErrorAssetManager from "../assets/CommonErrorAssetManager.bs.js";

CommonErrorAssetManager.importCss(undefined);

function CommonErrorCmp(Props) {
  var reload_cb = Props.reload_cb;
  return React.createElement("div", {
              className: "c-common-error-wrapper"
            }, React.createElement("div", {
                  className: "common-error-container"
                }, React.createElement("img", {
                      className: "common-error-image",
                      src: CommonErrorAssetManager.getImage("error.svg")
                    }), React.createElement(CommonErrorContentCmp.make, {
                      reload_cb: reload_cb
                    })));
}

var make = CommonErrorCmp;

export {
  make ,
  
}
/*  Not a pure module */
